import React, { lazy } from "react";
import { mainRoutes } from "./mainRoutes";
import { authRoutes } from "@/features/auth/routes/authRoutes";
import { evaluationFormsRoutes } from "@/features/evaluationForms/routes/evaluationFormsRoute";
import RouterErrorBoundary from "../errors/RouterErrorBoundary/RouterErrorBoundary";

const NotFound = lazy(() => import("../errors/NotFound/NotFound"));

export const routerConfig = [
  ...mainRoutes,
  ...authRoutes,
  ...evaluationFormsRoutes,

  {
    path: "*",
    element: <NotFound />,
    errorElement: <RouterErrorBoundary />,
  },
];
